export class ApiError extends Error {
  constructor(
    public readonly code: number,
    public readonly text: string,
  ) {
    super(`[${code}]: ${text}`);
  }
}
